export default __webpack_public_path__ + "static/media/bg-table.fc33b953.png";